export default "__VITE_ASSET__36b9176a__"